export const MIXPANEL_COMPONENT_NAME = 'Component Name';
export const MIXPANEL_CLICK_EVENT_NAME = 'Click Event Name';
export const MIXPANEL_IMPRESSION_EVENT_NAME = 'Impression Event Name';
